import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'semantic-ui-react';

import styles from './loaders.module.css';

const UiLoader = ( {
	message = '',
	...props
} ) => {
	return (
		<span className={ styles.uiLoader }>
			<Loader
				active
				inline
				inverted
				size="tiny"
				{ ...props }
			/>
			&nbsp;&nbsp;
			{ message }
		</span>
	);
};

UiLoader.propTypes = { message: PropTypes.string };

export default memo( UiLoader );
